import { Typography } from '@design-system/components/typography/typography';
import { SubscriptionBundlesVM } from '../../viewModel/subscriptionBundles.viewModel';
import { Link } from 'react-router';
import { sprinkles } from '@design-system/sprinkles.css';
import clsx from 'clsx';

export type SubscriptionDiscountsProps = Pick<
  SubscriptionBundlesVM['priceEditModal'],
  'discounts'
>;

export const SubscriptionDiscounts = ({
  discounts,
}: SubscriptionDiscountsProps) => {
  if (!discounts.data) {
    return (
      <div className="flex items-center justify-end px-2.5">
        <Link to={discounts.createDiscountPath}>
          <Typography variant="body" size="medium" color="P-80">
            Create new discount
          </Typography>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between px-2.5">
        <Typography variant="body" size="small">
          DISCOUNT CREATED:
        </Typography>
        <Link to={discounts.showDiscountsPath}>
          <Typography variant="body" size="medium" color="P-80">
            Manage Discounts
          </Typography>
        </Link>
      </div>
      <div className="flex items-center gap-4">
        <div
          className={clsx(
            'flex items-center gap-1',
            sprinkles({ color: discounts.disabled.monthly ? 'N-60' : 'B-100' }),
          )}
        >
          <Typography variant="body" size="small" fontWeight="normal">
            monthly:
          </Typography>
          <Typography variant="body" size="small" fontWeight="normal">
            {discounts.data.monthly}
          </Typography>
        </div>
        <div
          className={clsx(
            'flex items-center gap-1',
            sprinkles({ color: discounts.disabled.annual ? 'N-60' : 'B-100' }),
          )}
        >
          <Typography variant="body" size="small" fontWeight="normal">
            annual:
          </Typography>
          <Typography variant="body" size="small" fontWeight="normal">
            {discounts.data.annual}
          </Typography>
        </div>
      </div>
    </div>
  );
};
